<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="config-instagram-container">
        <!-- Header -->
        <div class="text-center mb-4">
          <h2 class="config-title">
            <i class="fab fa-instagram instagram-icon"></i>
            Configuração Instagram BOT
          </h2>
          <p class="text-muted">Configure a integração do seu chatbot com o Instagram Business</p>
        </div>

        <!-- Loading Geral -->
        <div *ngIf="carregando" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-2">Verificando conexão...</p>
        </div>

        <!-- Conteúdo Principal -->
        <div *ngIf="!carregando">

          <!-- Seção de Conexão (quando não conectado) -->
          <div *ngIf="!contaConectada" class="connection-section mb-4">
            <div class="connection-card">
              <div class="connection-icon mb-4">
                <i class="fab fa-instagram"></i>
              </div>
              <h4 class="connection-title mb-3">Conecte sua conta Instagram</h4>
              <p class="connection-subtitle mb-4">Conecte sua conta Instagram Business para ativar o chatbot automático</p>
              <button
                class="btn btn-connect"
                (click)="conectarInstagram()"
                [disabled]="carregandoConexao">
                <i class="fab fa-instagram"></i>
                <span *ngIf="!carregandoConexao">Conectar Instagram</span>
                <span *ngIf="carregandoConexao">
                  <span class="spinner-border spinner-border-sm me-1"></span>
                  Conectando...
                </span>
              </button>
            </div>
          </div>

          <!-- Status da Conexão (quando conectado) -->
          <div *ngIf="contaConectada" class="connected-status-card mb-4">
            <div class="d-flex align-items-center">
              <div class="status-icon-box me-3">
                <img *ngIf="contaConectada.imageProfileUrl"
                     [src]="contaConectada.imageProfileUrl"
                     class="profile-image"
                     alt="Instagram Profile">
                <div *ngIf="!contaConectada.imageProfileUrl" class="profile-placeholder">
                  <i class="fab fa-instagram"></i>
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="status-info">
                  <div class="status-badge mb-2">
                    <i class="fas fa-check-circle"></i> Instagram BOT Ativo
                  </div>
                  <div class="account-name">@{{contaConectada.nomeInstagram}}</div>
                  <div class="status-message">Chatbot instalado. Teste conversando com sua conta no Instagram.</div>

                  <div class="connection-dates mt-2">
                    <div class="date-item">
                      <small class="text-muted">
                        <i class="fas fa-calendar-plus"></i> Conectado em: {{contaConectada.dataCriacao | date:'dd/MM/yyyy HH:mm'}}
                      </small>
                    </div>
                    <div class="date-item" *ngIf="!tokenExpirado()">
                      <small [class.text-warning]="tokenProximoVencimento()">
                        <i class="fas fa-key"></i> Token expira em: {{contaConectada.dataExpiracao | date:'dd/MM/yyyy HH:mm'}}
                      </small>
                    </div>
                    <div class="date-item" *ngIf="tokenExpirado()">
                      <small class="text-danger">
                        <i class="fas fa-exclamation-triangle"></i> Token expirou em: {{contaConectada.dataExpiracao | date:'dd/MM/yyyy HH:mm'}}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button class="btn btn-disconnect" (click)="desconectar()">
                  <i class="fas fa-unlink"></i> Desconectar
                </button>
              </div>
            </div>
          </div>

          <!-- Mensagens de Sucesso/Erro -->
          <div *ngIf="sucesso" class="alert alert-success alert-dismissible fade show mb-4">
            <i class="fas fa-check-circle"></i> {{sucesso}}
            <button type="button" class="close" (click)="limparMensagens()">
              <span>&times;</span>
            </button>
          </div>

          <div *ngIf="erro" class="alert alert-danger alert-dismissible fade show mb-4">
            <i class="fas fa-exclamation-triangle"></i> {{erro}}
            <button type="button" class="close" (click)="limparMensagens()">
              <span>&times;</span>
            </button>
          </div>

          <!-- Configurações do Chatbot (apenas quando conectado) -->
          <div *ngIf="contaConectada && !tokenExpirado()" class="chatbot-section mb-4">
            <h5 class="section-title mb-4">Configurações do Chatbot</h5>

            <div class="chatbot-card">
              <div class="chatbot-header">
                <div class="robot-icon-container">
                  <i class="fas fa-robot"></i>
                </div>
                <h6 class="mb-3">Personalize as respostas automáticas</h6>
                <p class="text-muted">Configure mensagens de boas-vindas, cardápio digital e respostas para perguntas frequentes.</p>
              </div>

              <div class="features-section">
                <p class="features-label mb-3">
                  <i class="fas fa-magic"></i> Atalhos disponíveis:
                </p>
                <div class="feature-list">
                  <div class="feature-item">
                    <i class="fas fa-check"></i> Mensagem de boas-vindas personalizada
                  </div>
                  <div class="feature-item">
                    <i class="fas fa-check"></i> Cardápio automático
                  </div>
                  <div class="feature-item">
                    <i class="fas fa-check"></i> Horário de funcionamento
                  </div>
                  <div class="feature-item">
                    <i class="fas fa-check"></i> Informações da loja
                  </div>
                </div>
              </div>

              <div class="chatbot-actions">
                <a href="/admin/chatbot/configuracao-instagram" class="btn btn-chatbot">
                  <i class="fas fa-rocket"></i> Configurar Chatbot
                </a>
              </div>
            </div>
          </div>

          <!-- Token Expirado Warning -->
          <div *ngIf="contaConectada && tokenExpirado()" class="alert alert-warning mb-4">
            <h5 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Token Expirado</h5>
            <p>Seu token de acesso expirou. Para continuar usando o chatbot, você precisa renovar a conexão.</p>
            <hr>
            <button class="btn btn-warning" (click)="conectarInstagram()">
              <i class="fas fa-sync-alt"></i> Renovar Conexão
            </button>
          </div>

          <!-- Precisa de Ajuda? -->
          <div class="help-section">
            <h5 class="section-title mb-4">
              <i class="fas fa-question-circle"></i> Precisa de Ajuda?
            </h5>
            
            <div class="row">
              <div class="col-md-4 mb-3">
                <div class="help-card">
                  <div class="help-icon mb-3">
                    <i class="fas fa-comments"></i>
                  </div>
                  <h6>Mensagens Automáticas</h6>
                  <p class="text-muted small">Configure respostas automáticas para Instagram Direct<br>Templates prontos para atendimento 24/7</p>
                </div>
              </div>
              
              <div class="col-md-4 mb-3">
                <div class="help-card">
                  <div class="help-icon mb-3">
                    <i class="fas fa-star"></i>
                  </div>
                  <h6>Quebra-Gelos Automáticos</h6>
                  <p class="text-muted small">Perguntas frequentes predefinidas para iniciar conversas<br>Facilitam o primeiro contato entre cliente e empresa</p>
                </div>
              </div>
              
              <div class="col-md-4 mb-3">
                <div class="help-card">
                  <div class="help-icon mb-3">
                    <i class="fas fa-shopping-bag"></i>
                  </div>
                  <h6>Vendas e Catálogo</h6>
                  <p class="text-muted small">Envio automático do cardápio para clientes<br>Botão direto para WhatsApp da empresa</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
